import { MessageCircle, Phone, Mail, ArrowUpRight } from "lucide-react";
import { ChatVisual, CallVisual, EmailVisual } from "@/components/sections/ContactVisuals";

const WHATSAPP_URL = "https://wa.me/919117723765";
const TEL_URL = "tel:6362197389";
const MAIL_URL = "mailto:info@arjteam.top";

const cards = [
  {
    id: "whatsapp",
    title: "WhatsApp",
    sub: "Fastest reply • avg 2 min",
    handle: "Chat with ARJ",
    href: WHATSAPP_URL,
    target: "_blank",
    Icon: MessageCircle,
    iconBg: "from-[#10b981] to-[#0ea271]",
    label: "Open WhatsApp",
    Visual: ChatVisual,
  },
  {
    id: "call",
    title: "Call Us",
    sub: "Mon–Sat • 10am – 8pm IST",
    handle: "+91 63621 97389",
    href: TEL_URL,
    Icon: Phone,
    iconBg: "from-[#0066ff] to-[#0088ff]",
    label: "Dial Now",
    Visual: CallVisual,
  },
  {
    id: "email",
    title: "Email",
    sub: "We reply within 12 hours",
    handle: "info@arjteam.top",
    href: MAIL_URL,
    Icon: Mail,
    iconBg: "from-[#1f2937] to-[#0a0e1a]",
    label: "Send Email",
    Visual: EmailVisual,
  },
];

export default function ContactCards() {
  return (
    <section id="contact" data-testid="contact-section" className="relative py-20 sm:py-28 bg-paper-soft">
      <div className="absolute inset-0 bg-jaali opacity-60 pointer-events-none" />
      <div className="absolute inset-x-0 top-0 divider-glow" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
        <div className="max-w-2xl reveal">
          <div className="text-xs font-mono-d uppercase tracking-[0.28em] text-[#10b981] mb-3">
            / 05 — Get In Touch
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[0.98] tracking-tight text-[#0a0e1a]">
            Let’s build <span className="text-grad">something premium</span>.
          </h2>
          <p className="mt-5 text-[#475569] text-base sm:text-lg">
            Pick the channel that suits you. Real humans, fast response.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {cards.map((c, idx) => {
            const Icon = c.Icon;
            const Visual = c.Visual;
            return (
              <a
                key={c.id}
                data-testid={`contact-card-${c.id}`}
                href={c.href}
                target={c.target || undefined}
                rel={c.target ? "noopener noreferrer" : undefined}
                className="group surface-strong card-lift rounded-2xl overflow-hidden block reveal"
                style={{ transitionDelay: `${idx * 80}ms` }}
              >
                <div className="relative">
                  <Visual />
                  <div className="absolute bottom-3 left-3 z-[5]">
                    <span className={`grid place-items-center w-11 h-11 rounded-xl bg-gradient-to-br ${c.iconBg} text-white shadow-[0_8px_18px_-6px_rgba(10,15,30,0.4)]`}>
                      <Icon className="w-5 h-5" strokeWidth={2.4} />
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-start justify-between">
                    <div className="text-xs uppercase tracking-wider text-[#6b7280] font-mono-d">{c.title}</div>
                    <ArrowUpRight className="w-4 h-4 text-[#94a3b8] group-hover:text-[#0066ff] group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform" />
                  </div>
                  <div className="mt-1 font-display text-xl font-bold text-[#0a0e1a]">{c.handle}</div>
                  <div className="mt-1 text-sm text-[#6b7280]">{c.sub}</div>
                  <div className="mt-4 inline-flex items-center gap-1.5 text-sm font-bold text-[#0066ff]">
                    {c.label} <ArrowUpRight className="w-3.5 h-3.5" />
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
